import { AutogenModelSegAllocDetail, AutogenRowSegAllocDetail } from "./autogen/AutogenModelSegAllocDetail";

export class ModelSegAllocDetail extends AutogenModelSegAllocDetail<RowSegAllocDetail> {
	constructor() {
		super(RowSegAllocDetail);
	}
}

export class RowSegAllocDetail extends AutogenRowSegAllocDetail {
}